import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import ImportIcon from '../../../../../../components/icons/ImportIcon';
import InfoCircleIcon from '../../../../../../components/icons/InfoCircleIcon';
import ContactSpreadsheetImportInstructions from '../ContactSpreadsheetImportInstructions/ContactSpreadsheetImportInstructions';

const propTypes = {
  className: PropTypes.string,
};

const ContactSpreadsheetHeader = ({ className }) => {
  const [instructionsOpen, setInstructionsOpen] = useState(false);

  const classes = classNames({
    'contact-spreadsheet-import-header': true,
    [className]: !!className,
  });

  return (
    <Fragment>
      <div className={classes}>
        <h4 className="contact-spreadsheet-import-title">
          <ImportIcon color="#1a2e34" className="mr-1" size={16} /> Import
          contacts
        </h4>

        <a
          className="contact-spreadsheet-import-instructions-toggle"
          href="#"
          onClick={event => {
            event.preventDefault();
            setInstructionsOpen(true);
          }}
        >
          <InfoCircleIcon size={14} /> Import Instructions
        </a>
      </div>

      <ContactSpreadsheetImportInstructions
        forceOpen={instructionsOpen}
        onClose={() => setInstructionsOpen(false)}
      />
    </Fragment>
  );
};

ContactSpreadsheetHeader.propTypes = propTypes;

export default ContactSpreadsheetHeader;
